/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useEffect, useContext } from 'react';
import moment from 'moment';
import { Loader } from '@/components/custom/loader';
import { ProjectsContext } from './provider';
import { useSession } from 'src/app/hooks/useSession';
import useAuthorityLevel from '@/app/hooks/useAuthorityLevel';
import { useTranslation } from 'react-i18next';
import { EmptyState } from '@/components/custom/empty-state';
import { ProjectTimeline, ProjectTimelineCreate, ProjectTimelineGroup, ProjectTimelineItem, ProjectTimelineText, ProjectTimelineVersion, ProjectWorkspaceSidebar } from '@/components/custom/project';

export const ProjectsList = props => {
  const { t } = useTranslation();
  const { projectId } = props;
  const { session } = useSession();
  const id = session.user.id;
  const { loading, getProject, getProjectVersion, selectedProject, selectedProjectVersion } = useContext(ProjectsContext);
  const [ownProject, setOwnProject] = useState(true);
  const authorityLevel = useAuthorityLevel();

  function checkIfUserIsOnProjec(selectedProject, id) {
    return selectedProject?.users?.some(obj => obj.id === id);
  }

  useEffect(() => {
    if (projectId) {
      getProject(true, projectId);
    }
  }, [projectId]);

  useEffect(() => {
    if (selectedProject) {
      if (checkIfUserIsOnProjec(selectedProject, id) || authorityLevel !== 'student') {
        setOwnProject(true);
      } else {
        setOwnProject(false);
      }
    }
  }, [selectedProject, session]);

  return (
    ownProject && (
      <ProjectWorkspaceSidebar withMainNav>
        {loading && <Loader />}

        {!loading && selectedProject && (
          <ProjectTimeline>
            {selectedProject['project-versions'].map((pv, index) => (
              <ProjectTimelineItem
                key={index}
                onClick={() => getProjectVersion(pv.id)}
                active={selectedProjectVersion && pv.id === selectedProjectVersion.id}
              >
                <ProjectTimelineVersion>V.{pv.version}</ProjectTimelineVersion>
                <ProjectTimelineGroup>
                  <ProjectTimelineText>
                    {t('projects.versionProject')} {pv.version}.0
                  </ProjectTimelineText>
                  <ProjectTimelineCreate>
                    {t('projects.createdAt')} {moment(pv.created_at).format(t('datesForm.formatDate'))}
                  </ProjectTimelineCreate>
                </ProjectTimelineGroup>
              </ProjectTimelineItem>
            ))}
            {selectedProject.approved && <ProjectTimelineItem approved>🎉 Projeto aprovado!</ProjectTimelineItem>}
          </ProjectTimeline>
        )}

        {!selectedProjectVersion && !loading && (
          <EmptyState
            type="data"
            variant="plain"
            title={t('emptyState.missingDataTitle')}
            text={authorityLevel === 'admin' ? t('emptyState.textNoDataYet') : t('emptyState.submittingNewVersionText')}
          />
        )}
      </ProjectWorkspaceSidebar>
    )
  );
};
